import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import getCurrentBreakpoint, { onBreakpointChange } from '@project/shared/utils/breakpoints/js/breakpoints';


@createModule('ContactTeaserLarge')
/**
 * @author 
 */
export class ContactTeaserLarge extends TerrificSpec {
	$ctx: JQuery;

	start(resolve: Function) {
		
		this.initMobileHide(this._ctx);
		onBreakpointChange(() => this.initMobileHide(this._ctx));

		resolve();
	}

	stop() {}

	initMobileHide(ctx: HTMLElement) {
		const viewport = getCurrentBreakpoint() as string;
		if (viewport === 'small' || viewport === 'medium') {
			if ($(ctx).siblings().length == 0) {
				$(ctx).parent('.g-grid__item').hide();
			}
		} else {
			$(ctx).parent('.g-grid__item').removeAttr("style");
		}
	}
    
}
